import React from "react";
import styled from "styled-components";

import { SegmentedRow, SegmentedButton } from "./SegmentedButtons";

/**
 * A Google source's logo followed by one on/off button per figure the chart can draw from it, in one
 * pill: the Monitored URI chart's and the Issue deep dive's signal switches.
 */
export default function SourceToggles({ icon, source, toggles, onToggle }) {
    return (
        <SegmentedRow>
            <Logo src={icon} alt={source} title={source} />
            {toggles.map(({ key, label, on }) => (
                <SegmentedButton key={key} type="button" $active={on} aria-pressed={on} onClick={() => onToggle(key)}>{label}</SegmentedButton>
            ))}
        </SegmentedRow>
    );
}

const Logo = styled.img`
    width: 14px;
    height: 14px;
    margin: 0 4px 0 5px;
`;
